import { Fragment } from 'react'

import { Link } from '@tanstack/react-router'
import { DropDown } from 'ui/components'
import { TableButton } from 'ui/components/Buttons'

import { TableActionsWithIconsItem, TableActionsWithIconsProps } from './TableActionsProps'
import { DeleteItem, DetailsItem, EditItem, HistoryItem, ItemWithIcon } from './components'
import { getName, sortItems } from './utils'

import * as SC from './styles'

export const TableActionsWithIcons = (props: TableActionsWithIconsProps) => {
  const { items, dataQaAttribute } = props

  if (!items.length) {
    throw new Error('"TableActions" component needs at least one menu item.')
  }

  const { uniqueItems, baseItems } = sortItems<TableActionsWithIconsItem>(items)

  const renderItem = (item: TableActionsWithIconsItem, index: number) => (
    <Fragment key={index}>
      {item.type === 'delete' && <DeleteItem url={item.url} onClick={item.onClick} />}
      {item.type === 'edit' && <EditItem url={item.url} onClick={item.onClick} />}
      {item.type === 'details' && <DetailsItem url={item.url} onClick={item.onClick} />}
      {item.type === 'history' && <HistoryItem url={item.url} onClick={item.onClick} />}
      {item.type === 'option' && (
        <ItemWithIcon
          key={index}
          icon={item.icon}
          color={item.color}
          title={item.title}
          onClick={item.onClick}
          url={item.url}
        />
      )}
    </Fragment>
  )

  if (items.length > 1) {
    return (
      <DropDown menuPosition={'bottom-end'} dotsButtonQaAttribute={dataQaAttribute || 'Table-menu-dots-button'}>
        {uniqueItems.map((item, index) => renderItem(item, index))}
        {baseItems.length > 0 && (
          <>
            {uniqueItems.length > 0 && <SC.Divider />}
            <SC.BaseItemWrapper>{baseItems.map((item, index) => renderItem(item, index))}</SC.BaseItemWrapper>
          </>
        )}
      </DropDown>
    )
  }

  const title = uniqueItems.length ? getName(uniqueItems[0]) : getName(baseItems[0])
  const url = uniqueItems.length ? uniqueItems[0].url : baseItems[0].url
  const onClick = uniqueItems.length ? uniqueItems[0].onClick : baseItems[0].onClick

  return (
    <Link
      to={url}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <TableButton face={'neutral'}>{title}</TableButton>
    </Link>
  )
}
